import React from "react";

export type Variant =
  | "heading/2xl"
  | "heading/xl"
  | "heading/l"
  | "heading/m"
  | "heading/s"
  | "body/l"
  | "body/m"
  | "body/s";

export type TextProps = React.HTMLAttributes<HTMLElement> & {
  variant?: Variant;
  as?: React.ElementType;
  weight?: "regular" | "bold";
  underline?: boolean;
  children?: React.ReactNode;
};

const variantClasses: Record<Variant, string> = {
  // Heading
  "heading/2xl": "text-[30px] sm:text-[48px] leading-[1.65]", // mobile: 30px, sm: 48px
  "heading/xl": "text-[24px] sm:text-[36px] leading-[1.65]", // mobile: 24px, sm: 36px
  "heading/l": "text-[20px] sm:text-[30px] leading-[1.65]", // mobile: 20px, sm: 30px
  "heading/m": "text-[18px] sm:text-[24px] leading-[1.65]", // mobile: 18px, sm: 24px
  "heading/s": "text-[14px] sm:text-[16px] leading-[1.65]", // mobile: 14px, sm: 16px
  // Body
  "body/l": "text-[16px] sm:text-[24px] leading-loose", // mobile: 16px, sm: 24px
  "body/m": "text-[14px] sm:text-[16px] leading-loose", // mobile: 14px, sm: 16px
  "body/s": "text-[12px] sm:text-[14px] leading-loose", // mobile: 12px, sm: 14px
};

const Text: React.FC<TextProps> = ({
  variant = "body/m",
  as: Component = "p",
  weight = "regular",
  underline = false,
  className = "",
  children,
  ...rest
}) => {
  const variantClass = variantClasses[variant] || variantClasses["body/m"];

  // Heading は強制的に bold
  const isHeading = variant.startsWith("heading");
  const weightClass = isHeading ? "font-bold" : weight === "bold" ? "font-bold" : "font-normal";

  const underlineClass = underline ? "underline" : "";

  const baseClasses = ["font-sans", "tracking-wide"];

  // すべてのクラスを結合
  const classes = [...baseClasses, variantClass, weightClass, underlineClass, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Component className={classes || undefined} {...rest}>
      {children}
    </Component>
  );
};

export default Text;
